var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-view"},[_c('FilterCard',{attrs:{"add":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }